module.exports = __webpack_public_path__ + "officialStatic/img/solution-smart-factory1.9074f63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-smart-factory1.png
// module id = a+Cg
// module chunks = 0